<template>
  <section class="failure-page">
    <img
      v-lazy="require(`@/assets/images/common/failure.png`)"
      class="failure-img"
      alt="img"
    />
    <p class="tips">Failure</p>
    <button class="refresh-btn" @click="refresh">Retry</button>
  </section>
</template>

<script>
  export default {
    name: 'failure-page',
    methods: {
      refresh() {
        window.location.reload()
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
  }
</style>
